import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InputRange from 'react-input-range'

export default class AllFilters extends Component {
  static propTypes = {
    applyFilter: PropTypes.func,
    minBeds: PropTypes.number.isRequired,
    maxBeds: PropTypes.number.isRequired,
    onChange: PropTypes.func,
  }

  state = {
    value: null,
  }

  constructor (props) {
    super(props)

    this.state = {
      value: { min: props.minBeds, max: props.maxBeds },
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      value: { min: nextProps.minBeds, max: nextProps.maxBeds },
    })
  }

  applyFilter = () => {
    this.props.applyFilter({
      minBeds: this.state.value.min,
      maxBeds: this.state.value.max,
    })
  }

  handleChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value.min, value.max)
    } else {
      this.setState({ value })
    }
  }

  formatSingleValue (value, type) {
    if (type === 'value') {
      if (value === 1 || value === 10) {
        return ''
      }
    }

    if (value === 10) {
      return '10+'
    }

    return value
  }

  render () {
    const { applyFilter } = this.props
    const { value } = this.state

    return (
      <>
        <div className='form__group'>
          <label className='form__label text-emphasis'>Beds</label>
          <div className='form__control'>
            <InputRange
              formatLabel={this.formatSingleValue}
              minValue={1}
              maxValue={10}
              value={value}
              onChange={this.handleChange}
            />
          </div>
        </div>

        {applyFilter && <button type='button' className='btn btn--primary filter-button' onClick={this.applyFilter}>Apply filters</button>}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/filters/Beds.js